import React from 'react';
import { Row, Col, ListGroup, Button, Card, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Message from '../components/Message';
import { useGetOrderDetailsQuery } from '../slices/ordersApiSlice';

// NOT: Bu bileşen artık `veriCard` mutasyonunu ÇAĞIRMIYOR ve veritabanına
// yazmıyor. Ödemenin onaylanması (isPaid=true) artık backend'de,
// orderController.js -> handleCardVerificationSuccess içinde, bankadan gelen
// cevabın HashData'sı doğrulanarak yapılıyor. Bu ekran sadece o gerçek
// sonucu (order.isPaid) sorgulayıp gösteriyor. Eskiden olduğu gibi
// istemciden gelen resNumber'a güvenip veritabanı güncellemek, herhangi
// birinin /order/<id>/res/00 adresine gidip siparişi "ödendi" gibi
// göstermesine izin verirdi.
const CardVerification = () => {
  const { id, resNumber } = useParams();
  const navigate = useNavigate();

  const { data: order, isLoading, error } = useGetOrderDetailsQuery(id);

  const gotoPlaceOrder = () => navigate('/payment');
  const gotoHomeScreen = () => navigate('/');

  if (isLoading) {
    return (
      <Card>
        <ListGroup.Item className="text-center py-4">
          <Spinner animation="border" />
        </ListGroup.Item>
      </Card>
    );
  }

  if (error || !order) {
    return (
      <Card>
        <ListGroup.Item>
          <Message variant="danger">Sipariş bilgisi alınamadı.</Message>
        </ListGroup.Item>
      </Card>
    );
  }

  const knownErrorMessages = {
    '05': 'Ödeme Gerçekleşmedi',
    '93': 'Provizyon Alınamadı',
    '54': 'Kullanım tarihi geçmiş',
    HashDataError: 'Hash Data Eşleşmiyor',
    '14': 'Geçersiz Kart Numarası',
  };

  return (
    <Card>
      <ListGroup.Item>
        {order.isPaid ? (
          <Message variant="success">Ödeme Alındı</Message>
        ) : (
          <Message variant="danger">
            {knownErrorMessages[resNumber] || `Ödeme tamamlanamadı (${resNumber})`}
          </Message>
        )}
      </ListGroup.Item>

      {!order.isPaid && (
        <Row>
          <Col xs={12} md={8} lg={4}>
            <ListGroup.Item>
              <Button type="button" className="btn btn-block" onClick={gotoPlaceOrder}>
                Tekrar Dene
              </Button>
            </ListGroup.Item>
          </Col>
          <Col xs={8} md={8} lg={8}>
            <ListGroup.Item>
              <Button type="button" className="btn btn-block" onClick={gotoHomeScreen}>
                Markete Dön
              </Button>
            </ListGroup.Item>
          </Col>
        </Row>
      )}
    </Card>
  );
};

export default CardVerification;